import actionTypes from "../actionTypes";
import axios from "axios";
import constants from "../../utils/constants";
import { deleteEmptyProps } from "../../toolkit/utils/filter-utils";
import {
  successNotification,
  errorNotification
} from "../../utils/notifications";

const BASE_URL = `${constants.BASE_URL}/api/comisiones-manuales`;

export const clearComisionesManualExtras = () => ({
  type: actionTypes.CLEAR_COMISIONES_MANUALES_EXTRAS
});

export const getComisionesManualExtras = (fechaPago: string) => {
  return {
    type: actionTypes.GET_COMISIONES_MANUALES_EXTRAS,
    payload: axios.get(`${BASE_URL}/por-fecha-pago/extra`, {
      params: deleteEmptyProps({ fechaPago }),
      withCredentials: true
    })
  };
};

export const cargarComisionesDesdeExcel = (file: File, confirmar: boolean) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("confirmar", confirmar.toString());

  return {
    type: actionTypes.POST_COMISION_MANUAL_EXCEL,
    payload: axios.post(`${BASE_URL}/carga-excel`, formData, {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
  };
};

export const deleteComisionManual = (id: number, callback?: () => void) => {
  return {
    type: actionTypes.DELETE_COMISION_MANUAL,
    payload: axios
      .delete(`${BASE_URL}/${id}`, {
        withCredentials: true
      })
      .then(response => {
        successNotification("Comisión eliminada exitosamente");
        if (callback) callback();
        return response;
      })
      .catch(error => {
        errorNotification("Error al eliminar la comisión");
        throw error;
      })
  };
};
